import { Row, Col, Collapse } from "react-bootstrap";
import { useState, useRef, useEffect } from "react";
import "./HomePage.css";
import { useLang } from "../LangContext";
import { useTheme } from "../ThemeContext";
import { QuestionBlock, QuestionCard } from "./QuestionsModule";
import styles from "./PrivacyPage.module.css";

function QuestionsModule() {
  const [openedCard, setOpenedCard] = useState(null);
  const { lang, changeLang, t } = useLang();

  const cards = [
    {
      header: t("qHeader1"),
      isOpened: true,
      description: t("qDescr1"),
      key: 0,
    },
    {
      header: t("qHeader2"),
      isOpened: true,
      description: t("qDescr2"),
      key: 1,
    },
    {
      header: t("qHeader3"),
      isOpened: true,
      description: t("qDescr3"),
      key: 2,
    },
    {
      header: t("qHeader4"),
      isOpened: true,
      description: t("qDescr4"),
      key: 3,
    },
  ];
  return (
    <Row className="mt-2  gx-3 gy-3">
      <Col xs={12} md={12} lg={6}>
        <Row xs={1} className="gy-2">
          {cards.map((el) => (
            <Col>
              <QuestionCard
                {...el}
                isOpened={el.key === openedCard}
                setOpened={setOpenedCard}
                index={el.key}
                key={el.key}
              />
            </Col>
          ))}
        </Row>
      </Col>
      <Col xs={12} md={6} lg={3}>
        <QuestionBlock
          header={t("qCardHeader1")}
          description={t("qCardDescr1")}
          linkText={t("qCardLink1")}
          link={"https://wiki.qwins.co/"}
        />
      </Col>
      <Col xs={12} md={6} lg={3}>
        <QuestionBlock
          header={t("qCardHeader2")}
          description={t("qCardDescr2")}
          linkText={t("qCardLink2")}
          link={"https://t.me/qwinshelp"}
        />
      </Col>
    </Row>
  );
}

function MainBlock({ isXs, isSm, isMd }) {
  const { s, toggleTheme } = useTheme();
  const { lang, changeLang, t } = useLang();

  const btns = t("TPMainBlockContent");

  const isSmallScreen = isXs || isSm || isMd;

  const [opened, setOpened] = useState(0);
  return (
    <div className={styles.mainContainer} style={s.RMainBanner}>
      {!isSmallScreen && (
        <div className={styles.navCol}>
          <h6 className={styles.navHeader} style={{ color: s.navIconsColor }}>
            {t("TPNavigationHeader")}
          </h6>
          <div style={{ marginTop: "16px" }}>
            {btns.map((el, index) => (
              <div
                className={styles.navBtnContainer}
                style={
                  opened === index
                    ? s.PPSelectedParagraph
                    : { border: `1px solid ${s.RMainBanner.background}` }
                }
                key={index}
                onClick={() => setOpened(index)}
              >
                <span
                  className={styles.navBtnText}
                  style={{ color: s.navIconsColor }}
                >{`${index + 1}. ${el.header}`}</span>
              </div>
            ))}
          </div>
        </div>
      )}
      <div
        className={styles.contentCol}
        style={isSmallScreen ? {} : { paddingLeft: "92px" }}
      >
        <h6
          className={styles.navHeader}
          style={{ fontSize: "24px", color: s.navIconsColor }}
        >
          {t("TPPrivacyHeader")}
        </h6>
        <div style={{ marginTop: "40px" }}>
          {btns.map((el, index) => (
            <div key={index} onClick={() => setOpened(index)}>
              <h6
                className={styles.contentHeader}
                style={{ color: s.navIconsColor }}
              >{`${index + 1}. ${el.header}`}</h6>
              {(opened === index || isSmallScreen) &&
                el.items.map((item, itemIndex) => (
                  <div
                    key={itemIndex}
                    className={styles.contentItem}
                    style={{
                      ...s.PPSelectedParagraph,
                      color: s.ppSelectedText,
                    }}
                  >
                    {item}
                  </div>
                ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function TermsPage({ windowSize, setCurPage }) {
  const { lang, changeLang, t } = useLang();
  const { s, toggleTheme } = useTheme();

  return (
    <>
      <MainBlock
        isXs={windowSize.isXs}
        isSm={windowSize.isSm}
        isMd={windowSize.isMd}
      />
      <div style={{ textAlign: "left" }}>
        <h4
          className={`${styles.minorHeader} mt-5 mb-0`}
          style={{ ...s.minorHeader, fontFamily: "Gilroy-semibold" }}
        >
          {t("qMinorHeader")}
        </h4>
      </div>

      <QuestionsModule />
    </>
  );
}
